<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row v-if="!sectionEditMode" no-gutters align="center">
        <HoverItem
          v-if="currentSection"
          :item="currentSection"
          :is-delete="isDelete"
          @edit="changeEditMode(true)"
          @delete="$emit('delete-section', $event)"
        />
        <v-tooltip v-if="!sectionEditMode" bottom>
          <template v-slot:activator="{ on, attrs }">
            <IconBtn
              icons="mdi-plus"
              :disabled="itemCreatedMode"
              v-bind="attrs"
              @click="itemCreatedMode = true"
              v-on="on"
            />
          </template>
          <span>Додати завдання</span>
        </v-tooltip>
      </v-row>
      <TitleEditor
        v-else
        :value="currentSection"
        label="Найменування розділу*"
        @apply="
          $emit('update-section', {newSection: $event, currentSection});
          sectionEditMode = false;
        "
        @close="sectionEditMode = false"
      />
      <v-row v-if="itemCreatedMode" no-gutters>
        <v-textarea
          v-model="newItem.title"
          :error-messages="$v.newItem.title.$error ? errors.TITLE : []"
          :hide-details="false"
          label="Найменування завдання*"
          class="mr-5"
          auto-grow
          outlined
          rows="1"
          dense
          row-height="15"
        />
        <SectionSelect
          v-model="newItem.section"
          :error-messages="$v.newItem.section.$error ? errors.TITLE : []"
          label="Найменування розділу*"
          :items="sections"
          class="mr-5"
        />
        <v-btn icon :loading="loading" @click="createSpecificationItem">
          <v-icon color="green">
            check
          </v-icon>
        </v-btn>
        <v-btn icon @click="cancelCreatedItem">
          <v-icon color="red">
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SectionSelect from "../../../components/SectionSelect.vue";
import HoverItem from "../../../components/HoverItem.vue";
import TitleEditor from "../../../components/TitleEditor.vue";
import IconBtn from "../../../components/IconBtn.vue";

import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    SectionSelect,
    HoverItem,
    TitleEditor,
    IconBtn,
  },
  props: ["loading", "section", "sections", "sectionPosition", "isDelete"],
  data() {
    return {
      currentSection: "",
      sectionEditMode: false,
      newItem: {
        title: "",
        section: "",
        sectionPosition: 0,
      },
      itemCreatedMode: false,
    };
  },
  validations() {
    return {
      newItem: {
        title: {
          required,
        },
        section: {
          required,
        },
      },
    };
  },
  computed: {
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  watch: {
    section: {
      handler(val) {
        this.currentSection = val;
        this.newItem.section = val;
      },
      immediate: true,
    },
    sectionPosition: {
      handler(val) {
        this.newItem.sectionPosition = val;
      },
      immediate: true,
    },
  },
  methods: {
    createSpecificationItem() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      if (!this.sections.find((s) => s === this.newItem.section)) {
        this.newItem.sectionPosition = this.newItem.sectionPosition;
      }
      this.$emit("create-specification-item", this.newItem);
      this.cancelCreatedItem();
    },
    cancelCreatedItem() {
      this.itemCreatedMode = false;
      this.$v.$reset();
      this.newItem = {
        title: "",
        section: this.section ? this.section : "",
        sectionPosition: this.sectionPosition ? this.sectionPosition : 0,
      };
    },
    changeEditMode(val) {
      this.sectionEditMode = val;
      if (val) {
        this.itemCreatedMode = false;
      }
    },
  },
};
</script>
